import WOTemplateDataGrid from './WOTemplateDataGrid';

export default WOTemplateDataGrid;
export * from './WOTemplateDataGrid';
